(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2232],{

/***/ 92499:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/contracts/[category]/[contract]",
      function () {
        return __webpack_require__(94151);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_pdf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32191);
/* harmony import */ var react_pdf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47373);
/* harmony import */ var react_pdf__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(59037);
/* harmony import */ var _constants_contracts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56298);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8193);
/* harmony import */ var _contract_module_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2360);
/* harmony import */ var _contract_module_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_contract_module_css__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(5434);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55678);
/* harmony import */ var _utils_mixpanel__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43110);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2208);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(63750);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10447);
/* harmony import */ var react_icons_bi__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47516);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56475);






















react_pdf__WEBPACK_IMPORTED_MODULE_13__/* ["default"].GlobalWorkerOptions.workerSrc */ .Z.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(react_pdf__WEBPACK_IMPORTED_MODULE_13__/* ["default"].version */ .Z.version, "/pdf.worker.js");
const addHyphenInUrl = (str)=>{
    return str.replace(/\s+/g, "-").toLowerCase();
};
const Contract = (param)=>{
    let { contractData , relatedContracts  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { contract , category  } = router.query;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z);
    const [numPages, setNumPages] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [pageNumber, setPageNumber] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1);
    const [clickedButton, setClickedButton] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const [email, setEmail] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [emailError, setEmailError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const [downloadLoading, setDownloadLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [showBoloformsModal, setShowBoloformsModal] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [showDownloadModal, setShowDownloadModal] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [sticyButtonVisible, setSticyButtonVisible] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [isLegalTemplate, setIsLegalTemplate] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const htmlElement = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const emailToggler = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    function onDocumentLoadSuccess(param) {
        let { numPages  } = param;
        setNumPages(numPages);
    }
    const nextPage = (pageNumber)=>{
        if (pageNumber < numPages) {
            setPageNumber(pageNumber + 1);
        }
    };
    const previousPage = (pageNumber)=>{
        if (pageNumber > 1) {
            setPageNumber(pageNumber - 1);
        }
    };
    const downloadAsPdf = async ()=>{
        let newEl = document.createElement("a");
        newEl.href = contractData === null || contractData === void 0 ? void 0 : contractData.pdfLink;
        newEl.target = "_self";
        newEl.download = contractData === null || contractData === void 0 ? void 0 : contractData.contract_name;
        newEl.click();
    };
    const downloadAsDoc = async ()=>{
        let newEl = document.createElement("a");
        newEl.href = contractData === null || contractData === void 0 ? void 0 : contractData.docLink;
        newEl.download = contractData === null || contractData === void 0 ? void 0 : contractData.contract_name;
        newEl.click();
    };
    const validateEmail = ()=>{
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        if (!emailRegex.test(email)) {
            setEmailError("Please enter a valid email address");
        } else {
            setEmailError("");
        }
    };
    const handleBlur = ()=>{
        validateEmail();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        // console.log("=========contractData=========", contractData);
        if (true) {
            updateScreenSize();
            window.addEventListener("resize", updateScreenSize);
            return ()=>{
                window.removeEventListener("resize", updateScreenSize);
            };
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        console.log("checking for legal template");
        if (_constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .legalTemplatesMapping */ .DH[contract]) {
            setIsLegalTemplate(true);
        } else {
            setIsLegalTemplate(false);
        }
    }, [
        contract
    ]);
    const handleExport = async (exportType, newSubscriber)=>{
        validateEmail();
        if (emailError) {
            return;
        }
        if (newSubscriber) {
            if (email === "") {
                return;
            }
            setDownloadLoading(true);
            localStorage.setItem("BoloformsEmail", email);
            const subscribeEmail = await fetch("".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_URL_POST, "subscribe-email"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email
                })
            });
            // console.log(subscribeEmail);
            const saveOwner = await fetch("".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.SIGNATURE_BASE_URL, "/owners"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email,
                    from: "CONTRACTS"
                })
            });
            if (exportType === "Pdf") {
                // downloadAsPdf();
                if (isLegalTemplate) {
                    window.open("https://formlocator.net/?template_id=".concat(_constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .legalTemplatesMapping */ .DH[contractData === null || contractData === void 0 ? void 0 : contractData.slug]), "_blank");
                } else {
                    router.push("/signature/download-success?category=".concat(category, "&contract_name=").concat(contractData === null || contractData === void 0 ? void 0 : contractData.name, "&pdfLink=").concat(contractData === null || contractData === void 0 ? void 0 : contractData.pdfLink));
                }
            }
            if (exportType === "Doc") {
                router.push("/signature/download-success?category=".concat(category, "&contract_name=").concat(contractData === null || contractData === void 0 ? void 0 : contractData.name, "&pdfLink=").concat(contractData === null || contractData === void 0 ? void 0 : contractData.pdfLink));
            // downloadAsDoc();
            }
            setDownloadLoading(false);
            closeEmailPrompt();
            setShowBoloformsModal(true);
            return;
        }
        if (!newSubscriber) {
            if (isLegalTemplate) {
                window.open("https://formlocator.net/?template_id=".concat(_constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .legalTemplatesMapping */ .DH[contractData === null || contractData === void 0 ? void 0 : contractData.slug]), "_blank");
            } else {
                router.push("/signature/download-success?category=".concat(category, "&contract_name=").concat(contractData === null || contractData === void 0 ? void 0 : contractData.name, "&pdfLink=").concat(contractData === null || contractData === void 0 ? void 0 : contractData.pdfLink));
            }
            // await downloadAsPdf();
            if (exportType === "Doc") {
                router.push("/signature/download-success?category=".concat(category, "&contract_name=").concat(contractData === null || contractData === void 0 ? void 0 : contractData.name, "&pdfLink=").concat(contractData === null || contractData === void 0 ? void 0 : contractData.pdfLink));
            // await downloadAsDoc();
            }
            setShowBoloformsModal(true);
            return;
        }
    };
    const openEmailPrompt = (promptType)=>{
        if (true) {
            const storedEmail = localStorage.getItem("BoloformsEmail");
            if (!storedEmail) {
                setClickedButton(promptType);
                emailToggler.current.classList.toggle("hidden");
                return;
            } else {
                setEmail(storedEmail);
                handleExport(promptType, false);
                return;
            }
        }
    };
    const closeEmailPrompt = ()=>{
        emailToggler.current.classList.toggle("hidden");
        return;
    };
    const [screenSize, setScreenSize] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        width: 0,
        height: 0
    });
    const updateScreenSize = ()=>{
        setScreenSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    const handleScroll = ()=>{
        const scrollY = window.scrollY || window.pageYOffset;
        if (scrollY > 800) {
            setSticyButtonVisible(true);
        } else {
            setSticyButtonVisible(false);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full mt-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                        children: [
                            contractData === null || contractData === void 0 ? void 0 : contractData.metaTitle,
                            " | BoloForms"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "".concat(contractData === null || contractData === void 0 ? void 0 : contractData.metaDescription)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "".concat(contractData === null || contractData === void 0 ? void 0 : contractData.metaKeywords)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/contracts/".concat(addHyphenInUrl(contractData === null || contractData === void 0 ? void 0 : contractData.categories), "/").concat(contractData === null || contractData === void 0 ? void 0 : contractData.slug, "/")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "".concat(contractData === null || contractData === void 0 ? void 0 : contractData.metaTitle, " | BoloSign")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/contracts/".concat(addHyphenInUrl(contractData === null || contractData === void 0 ? void 0 : contractData.categories), "/").concat(contractData === null || contractData === void 0 ? void 0 : contractData.slug, "/")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "".concat(contractData === null || contractData === void 0 ? void 0 : contractData.metaTitle, " | BoloSign")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "".concat(contractData === null || contractData === void 0 ? void 0 : contractData.metaDescription)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "".concat(contractData === null || contractData === void 0 ? void 0 : contractData.metaDescription)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        content: "https://www.bolosign.com/signature/contracts/".concat(addHyphenInUrl(contractData === null || contractData === void 0 ? void 0 : contractData.categories), "/").concat(contractData === null || contractData === void 0 ? void 0 : contractData.slug, "/")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: emailToggler,
                className: "fixed w-full h-[100vh] bg-gray-800/80 left-0 top-0 z-[2000] flex justify-center items-center p-5 hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-[700px] p-8 md:py-10 md:px-20 bg-white rounded-3xl text-gray-700 flex gap-3 md:gap-7 flex-col justify-between items-center relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onClick: ()=>{
                                setEmailError("");
                                setEmail("");
                                closeEmailPrompt();
                            },
                            className: "md:w-[50px] md:h-[50px] bg-white/60 border border-violet-800 rounded-full close absolute top-[-10px] right-[-10px] md:top-[-20px] md:right-[-20px] text-violet-600 text-4xl font-bold cursor-pointer hover:text-red-500 grid place-items-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_14__/* .AiOutlineClose */ .oHP, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: "text-xl md:text-3xl",
                            children: [
                                "Download",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-violet-600",
                                    children: contractData === null || contractData === void 0 ? void 0 : contractData.secondaryName
                                }),
                                " ",
                                clickedButton
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full flex flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-gray-600 font-bold text-lg",
                                    children: "Your Email"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    value: email,
                                    onChange: (e)=>setEmail(e.target.value),
                                    onBlur: handleBlur,
                                    className: "w-full h-[60px] rounded-full border px-8 outline-none",
                                    type: "email",
                                    placeholder: "myemail@gmail.com",
                                    name: "",
                                    id: ""
                                }),
                                emailError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-red-400 font-bold",
                                    children: emailError
                                }),
                                downloadLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "ml-[20px] flex items-center mt-5 text-gray-600 space-x-2 ".concat((_contract_module_css__WEBPACK_IMPORTED_MODULE_15___default().loader)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-violet-600",
                                            children: "Downloading"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-2 h-2 bg-violet-600 rounded-full animate-bounce"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-2 h-2 bg-violet-600 rounded-full animate-bounce"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-2 h-2 bg-violet-600 rounded-full animate-bounce"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-gray-600 mt-5",
                                    children: [
                                        "Download your template as a ",
                                        clickedButton,
                                        " file."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    onClick: ()=>handleExport(clickedButton, true),
                                    className: "w-full bg-violet-600 text-white text-xl py-4 rounded-full hover:opacity-90",
                                    children: [
                                        "Download ",
                                        clickedButton
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            showBoloformsModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed z-[1000] top-0 left-0 w-full flex justify-center items-start px-[5px] py-[100px] bg-white/60 min-h-screen",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative flex flex-col md:flex-row justify-center items-center w-fit bg-violet-500 rounded-2xl mx-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onClick: ()=>setShowBoloformsModal(false),
                            className: "border border-b-none border-violet-300 shadow-xl absolute top-[-25px] left-[50%] -translate-x-[50%] w-[50px] h-[50px] hover:opacity-90 rounded-full cursor-pointer grid place-items-center bg-white text-violet-600 font-bold text-[20px]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_14__/* .AiOutlineClose */ .oHP, {
                                className: "font-bold"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "lg:w-[500px] md:h-[250px] lg:h-[250px] text-white flex flex-col justify-between gap-[50px] md:gap-[10px] p-[50px] px-[20px] lg:px-[50px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-[25px] font-semibold",
                                    children: "Do you want to send this for signature?"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "self-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        target: "_blank",
                                        href: "https://signature.boloforms.com/login?from=".concat(context.globalData.from || "CONTRACTS").concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_11__/* .createUTMQueryParams */ .T0)({
                                            utmData_: context.globalData.utmData,
                                            from: "CONTRACTS"
                                        })),
                                        className: "bg-white text-violet-600 text-[17px] md:text-[20px] px-[20px] py-[8px] md:px-[40px] md:py-[12px] rounded-full hover:opacity-80",
                                        children: "Get started for Free"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            sticyButtonVisible && (_constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .legalTemplatesMapping */ .DH[contractData === null || contractData === void 0 ? void 0 : contractData.slug] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_12__/* .CLMButtonPrimary */ .IS, {
                buttonText: "Create Document",
                buttonUrl: "https://formlocator.net/?template_id=".concat(_constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .legalTemplatesMapping */ .DH[contractData === null || contractData === void 0 ? void 0 : contractData.slug]),
                rel: "nofollow noreferrer noopener",
                newTab: true,
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_16__/* .BiPencil */ .n2B, {})
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_12__/* .CLMButtonPrimary1 */ .au, {
                buttonText: "Create Document",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_16__/* .BiPencil */ .n2B, {}),
                onClick: ()=>{
                    new _utils_mixpanel__WEBPACK_IMPORTED_MODULE_9__["default"]().track("Contracts", {
                        billing_action: "contract_click_download",
                        contract: contractData === null || contractData === void 0 ? void 0 : contractData.name
                    });
                    setShowDownloadModal((prev)=>!prev);
                }
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-screen-xl mx-auto flex flex-col scroll-smooth px-4 lg:px-8 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-2 text-gray-900 text-md mb-5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                className: "hover:text-violet-600",
                                href: "/signature/contracts",
                                children: "Home"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "",
                                children: ">"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                className: "hover:text-violet-700",
                                href: "/signature/contracts/".concat(addHyphenInUrl(contractData === null || contractData === void 0 ? void 0 : contractData.categories)),
                                children: contractData === null || contractData === void 0 ? void 0 : contractData.categories
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "",
                                children: ">"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: contractData === null || contractData === void 0 ? void 0 : contractData.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col-reverse xl:flex-row justify-between gap-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col gap-10 flex-1",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col gap-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                                style: {
                                                    lineHeight: 1.2
                                                },
                                                className: "text-3xl sm:text-5xl text-black",
                                                children: [
                                                    "Download ",
                                                    contractData === null || contractData === void 0 ? void 0 : contractData.secondaryName
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-xl text-gray-900",
                                                children: contractData === null || contractData === void 0 ? void 0 : contractData.secondaryDescription
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex flex-col gap-3 sm:gap-0 sm:flex-row sm:items-center",
                                                children: _constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .legalTemplatesMapping */ .DH[contractData === null || contractData === void 0 ? void 0 : contractData.slug] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_12__/* .CLMButtonPrimary */ .IS, {
                                                    buttonText: "Create Document",
                                                    buttonUrl: "https://formlocator.net/?template_id=".concat(_constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .legalTemplatesMapping */ .DH[contractData === null || contractData === void 0 ? void 0 : contractData.slug]),
                                                    rel: "nofollow noreferrer noopener",
                                                    newTab: true,
                                                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_16__/* .BiPencil */ .n2B, {})
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_12__/* .CLMButtonPrimary1 */ .au, {
                                                    buttonText: "Create Document",
                                                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_16__/* .BiPencil */ .n2B, {}),
                                                    onClick: ()=>{
                                                        new _utils_mixpanel__WEBPACK_IMPORTED_MODULE_9__["default"]().track("Contracts", {
                                                            billing_action: "contract_click_download",
                                                            contract: contractData === null || contractData === void 0 ? void 0 : contractData.name
                                                        });
                                                        setShowDownloadModal((prev)=>!prev);
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    isLegalTemplate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex -mt-6 text-[12px]",
                                        children: [
                                            "Powered by",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                className: "mx-2",
                                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/legal-templates.ico"),
                                                alt: "LegalTemplates",
                                                width: 20,
                                                height: 15
                                            }),
                                            "LegalTemplates."
                                        ]
                                    }),
                                    (contractData === null || contractData === void 0 ? void 0 : contractData.hasState) === "TRUE" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col gap-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "text-gray-900 text-xl",
                                                children: [
                                                    "Select your state below to find a",
                                                    " ",
                                                    contractData === null || contractData === void 0 ? void 0 : contractData.secondaryName
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex w-fit items-center flex-wrap p-8 border border-gray-700 rounded-xl",
                                                children: _constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .statesOfUSA.map */ .OS.map((state, index)=>{
                                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "md:w-1/5 sm:w-1/3 w-1/2 mb-3",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                            className: "",
                                                            href: "/signature/contracts/".concat(addHyphenInUrl(contractData === null || contractData === void 0 ? void 0 : contractData.categories), "/").concat(contractData === null || contractData === void 0 ? void 0 : contractData.slug, "/").concat(addHyphenInUrl(state.label)),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "underline text-[14px] text-gray-900 hover:text-violet-500",
                                                                children: state.label
                                                            })
                                                        })
                                                    }, index);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "contract-data flex flex-col",
                                        dangerouslySetInnerHTML: {
                                            __html: contractData === null || contractData === void 0 ? void 0 : contractData.content
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        title: "Download ".concat(contractData === null || contractData === void 0 ? void 0 : contractData.secondaryName, " PDF"),
                                        className: "w-full pdf-preview",
                                        id: "preview-".concat(addHyphenInUrl(contractData === null || contractData === void 0 ? void 0 : contractData.name)),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                className: "border border-gray-700 w-fit mx-auto",
                                                file: "".concat(contractData === null || contractData === void 0 ? void 0 : contractData.pdfLink),
                                                onLoadSuccess: onDocumentLoadSuccess,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                    width: screenSize.width < 800 ? screenSize.width - 80 : 700,
                                                    renderTextLayer: false,
                                                    renderAnnotationLayer: false,
                                                    pageNumber: pageNumber
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mt-5 flex gap-5 items-center justify-center",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex gap-2 items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                            className: "bg-white text-3xl hover:opacity-90 text-black text-center",
                                                            onClick: ()=>previousPage(pageNumber),
                                                            children: [
                                                                "",
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_19__/* .BsArrowLeftSquareFill */ .hPB, {})
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "",
                                                            children: [
                                                                "Page ",
                                                                pageNumber,
                                                                " of ",
                                                                numPages
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            className: "bg-white text-3xl hover:opacity-90 text-black text-center",
                                                            onClick: ()=>nextPage(pageNumber),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_19__/* .BsFillArrowRightSquareFill */ .Mcl, {})
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mt-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "text-4xl font-semibold text-black",
                                                children: [
                                                    "Related ",
                                                    contractData === null || contractData === void 0 ? void 0 : contractData.subcategories,
                                                    " Contracts"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                className: "flex flex-col gap-3 mt-5 list-disc ml-10 mxl:ml-0",
                                                children: relatedContracts === null || relatedContracts === void 0 ? void 0 : relatedContracts.map((contract, index)=>{
                                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                        className: "text-lg text-gray-900",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                                href: "/signature/contracts/".concat(addHyphenInUrl(contractData === null || contractData === void 0 ? void 0 : contractData.categories), "/").concat(contract === null || contract === void 0 ? void 0 : contract.slug),
                                                                className: "hover:text-violet-500 underline font-semibold",
                                                                children: contract === null || contract === void 0 ? void 0 : contract.name
                                                            }),
                                                            " ",
                                                            ": ",
                                                            contract === null || contract === void 0 ? void 0 : contract.secondaryDescription
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                title: "Download ".concat(contractData === null || contractData === void 0 ? void 0 : contractData.secondaryName, " PDF"),
                                className: "flex justify-between items-center mx-auto flex-col pdf-container border border-gray-400 rounded-lg   p-5 xl:sticky top-[120px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        className: "border w-fit my-auto mb-3",
                                        file: "".concat(contractData === null || contractData === void 0 ? void 0 : contractData.pdfLink),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            width: screenSize.width < 425 ? screenSize.width - 100 : 340,
                                            pageNumber: 1,
                                            renderTextLayer: false,
                                            renderAnnotationLayer: false
                                        })
                                    }),
                                    _constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .legalTemplatesMapping */ .DH[contractData === null || contractData === void 0 ? void 0 : contractData.slug] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_12__/* .CLMButtonPrimary */ .IS, {
                                        buttonText: "Create Document",
                                        buttonUrl: "https://formlocator.net/?template_id=".concat(_constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .legalTemplatesMapping */ .DH[contractData === null || contractData === void 0 ? void 0 : contractData.slug]),
                                        rel: "nofollow noreferrer noopener",
                                        newTab: true,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_16__/* .BiPencil */ .n2B, {})
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_12__/* .CLMButtonPrimary1 */ .au, {
                                        buttonText: "Create Document",
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_16__/* .BiPencil */ .n2B, {}),
                                        onClick: ()=>{
                                            new _utils_mixpanel__WEBPACK_IMPORTED_MODULE_9__["default"]().track("Contracts", {
                                                billing_action: "contract_click_download",
                                                contract: contractData === null || contractData === void 0 ? void 0 : contractData.name
                                            });
                                            setShowDownloadModal((prev)=>!prev);
                                        }
                                    }),
                                    isLegalTemplate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex mt-2 text-[12px]",
                                        children: [
                                            "Powered by",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                className: "mx-2",
                                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/legal-templates.ico"),
                                                alt: "LegalTemplates",
                                                width: 20,
                                                height: 15
                                            }),
                                            "LegalTemplates."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showDownloadModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DownloadContractModal, {
                contractData: contractData,
                contract: contract,
                setShowDownloadModal: setShowDownloadModal
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_toastify__WEBPACK_IMPORTED_MODULE_8__/* .ToastContainer */ .Ix, {
                className: "text-xs",
                // theme="dark"
                position: "bottom-right"
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Contract);
const DownloadContractModal = (param)=>{
    let { contractData , contract , setShowDownloadModal  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const [email, setEmail] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(localStorage.getItem("BoloformsEmail"));
    const validateEmail = (email)=>{
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        return emailRegex.test(email);
    };
    const checkForLegalTemplate = ()=>{
        console.log("legalTemplatesMapping", contractData === null || contractData === void 0 ? void 0 : contractData.slug, _constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .legalTemplatesMapping */ .DH[contractData === null || contractData === void 0 ? void 0 : contractData.slug]);
        if (_constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .legalTemplatesMapping */ .DH[contractData === null || contractData === void 0 ? void 0 : contractData.slug]) {
            return true;
        }
        return false;
    };
    const handleDownload = async (type)=>{
        try {
            let isNewSubscriber = !localStorage.getItem("BoloformsEmail");
            if (true) {
                if (!validateEmail(email)) {
                    return react_toastify__WEBPACK_IMPORTED_MODULE_8__/* .toast.error */ .Am.error("Please enter a valid email address");
                } else {
                    if (isNewSubscriber) {
                        // console.log("New Subscriber");
                        const subscribeEmail = await fetch("".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_URL_POST, "subscribe-email"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                email: email
                            })
                        });
                        // console.log(subscribeEmail);
                        const saveOwner = await fetch("".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.SIGNATURE_BASE_URL, "/owners"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                email: email,
                                from: "CONTRACTS"
                            })
                        });
                        localStorage.setItem("BoloformsEmail", email);
                    }
                    if (type === "free") {
                        // let newEl = document.createElement("a");
                        // newEl.href = contractData?.pdfLink;
                        // newEl.target = "_self";
                        // newEl.download = contractData?.contract_name;
                        // newEl.click();
                        new _utils_mixpanel__WEBPACK_IMPORTED_MODULE_9__["default"]().track("Contracts", {
                            billing_action: "contract_click_download_free",
                            contract: contractData === null || contractData === void 0 ? void 0 : contractData.name
                        });
                        new _utils_mixpanel__WEBPACK_IMPORTED_MODULE_9__["default"]().increment("contract_click_download_free");
                        // console.log("legalTemplatesMapping", legalTemplatesMapping);
                        if (checkForLegalTemplate()) {
                            // redirect to legal template
                            window.open("https://formlocator.net/?template_id=".concat(_constants_contracts__WEBPACK_IMPORTED_MODULE_6__/* .legalTemplatesMapping */ .DH[contractData === null || contractData === void 0 ? void 0 : contractData.slug]), "_blank");
                        } else {
                            router.push("/signature/contracts/download-success?category=".concat(addHyphenInUrl(contractData === null || contractData === void 0 ? void 0 : contractData.categories), "&contract_name=").concat(contractData === null || contractData === void 0 ? void 0 : contractData.name, "&pdfLink=").concat(contractData === null || contractData === void 0 ? void 0 : contractData.pdfLink, "&utm_source=").concat(contractData === null || contractData === void 0 ? void 0 : contractData.name));
                        }
                    }
                    if (type === "paid") {
                        let paymentDetails = await fetch("".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.SIGNATURE_PAYMENTS_BASE_URL, "/createStripeOneTimePaymentUS"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                priceId: "price_1OxNZ0LiGbRu8waGVSTwEeCe",
                                quantity: 1,
                                ownerEmail: email,
                                cancelUrl: window.location.href,
                                successUrl: "https://www.boloforms.com/pdf-editor/?pdfUrl=".concat(contractData === null || contractData === void 0 ? void 0 : contractData.pdfLink, "&contract=").concat(contract, "&whichFlow=DOWNLOAD&isPaid=true")
                            })
                        });
                        paymentDetails = await paymentDetails.json();
                        console.log("paymentDetails", paymentDetails);
                        window.open(paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.sessionUrl, "_self");
                        new _utils_mixpanel__WEBPACK_IMPORTED_MODULE_9__["default"]().track("Contracts", {
                            billing_action: "contract_click_download_payment_started",
                            contract: contractData === null || contractData === void 0 ? void 0 : contractData.name
                        });
                        new _utils_mixpanel__WEBPACK_IMPORTED_MODULE_9__["default"]().increment("contract_click_download_payment_started");
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "fixed w-full h-[100vh] bg-gray-800/80 left-0 top-0 z-[2000] flex justify-center items-center p-5",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-[700px] px-8 py-12 md:px-20 bg-white rounded-3xl text-gray-700 flex gap-3 md:gap-7 flex-col justify-between items-center relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_20__/* .MdClose */ .FU5, {
                        onClick: ()=>setShowDownloadModal((prev)=>!prev),
                        className: "absolute top-5 right-5 text-2xl cursor-pointer imageBorders"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-base md:text-3xl text-black",
                                children: "Please provide your email"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-900 mt-3 text-xs md:text-base",
                                children: "Create your contract for free."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full mt-3 md:mt-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-900 font-bold text-xs md:text-sm mb-1",
                                children: "Your Email"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                className: "w-full py-2.5 md:py-3 text-gray-800 rounded-md border-2 px-4 outline-none text-sm md:text-base border-gray-700 placeholder-gray-800",
                                type: "email",
                                placeholder: "Enter your email",
                                value: email,
                                onChange: (e)=>setEmail(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full flex flex-col gap-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: ()=>handleDownload("free"),
                            className: "w-full bg-black text-white rounded-md border-2 border-black font-bold text-sm md:text-base py-3 transition-all duration-500 ease-in-out hover:bg-black/90 hover:border-black",
                            children: "Create Now"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_toastify__WEBPACK_IMPORTED_MODULE_8__/* .ToastContainer */ .Ix, {
                className: "text-xs",
                // theme="dark"
                position: "bottom-right"
            })
        ]
    });
};


/***/ }),

/***/ 2360:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader":"contract_loader__uD0oO","topPreview":"contract_topPreview___2oVd","pdfPreview":"contract_pdfPreview__vl1C1"};

/***/ }),

/***/ 69349:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 49080:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 57588:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 3071:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 15232:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,4617,3701,9846,9774,2888,179], function() { return __webpack_exec__(92499); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);